import { faTrash } from "@fortawesome/pro-solid-svg-icons"
import { translate } from "app/language/service"
import { campaignRPO } from "campaign/repository"
import { messageSVC } from "message/service"
import { refreshCampaignList } from "./list"

export function deleteCampaign(campaignId: number, campaignName: string, isForecast: boolean): Promise<boolean> {
  return new Promise<boolean>((resolve, reject) => {
    messageSVC.confirmMessage({
      icon: faTrash,
      addGenericConfirmMessage: true,
      confirmButtonLabel: translate("button.delete"),
      title: isForecast ? translate("forecast.delete.confirm.title") : translate("campaign.delete.confirm.title"),
      message: translate(
        isForecast ? "forecast.delete.confirm.message" : "campaign.delete.confirm.message",
        campaignName
      ),
      onSuccess: async () => {
        await campaignRPO.update({ id: campaignId, status_id: "temporary" })
        refreshCampaignList({ isForecast, isDspDeal: false })
        resolve(true)
      },
      onCancel: () => resolve(false)
    })
  })
}
